import { render, staticRenderFns } from "./confluence.vue?vue&type=template&id=3ccf45da&scoped=true&"
import script from "./confluence.vue?vue&type=script&lang=js&"
export * from "./confluence.vue?vue&type=script&lang=js&"
import style0 from "./confluence.vue?vue&type=style&index=0&id=3ccf45da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ccf45da",
  null
  
)

export default component.exports